import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { RenderTextareaField, RenderField } from '@zola/zola-ui';

import { RenderDatePicker } from '../../../../common/form';
import * as Validations from '../../../../common/form/commonValidations';

import ChecklistSaveCancelButtons from '../../ChecklistSaveCancelButtons';

import './DateNoteForm.less';

const DateNoteForm = ({ handleSubmit, onCancel, isCustomTask }) => (
  <form onSubmit={handleSubmit} className="checklist__dateNote--form">
    {isCustomTask && (
      <div className="visible-xs visible-sm">
        <Field
          name="title"
          type="text"
          id="checklist-task-title"
          required
          component={RenderField}
          className="zola-ui render-field"
          validate={[Validations.REQUIRED]}
          label="Title"
          autoFocus
        />
      </div>
    )}
    <Field
      name="due_at"
      type="date"
      id="checklist-task-due-at"
      required
      component={RenderDatePicker}
      className="zola-ui render-field"
      placeholder="MM/DD/YYYY"
      validate={[Validations.REQUIRED, Validations.DATE]}
      label="Due Date"
    />
    <Field
      id="task-note"
      placeholder="Add a note..."
      name="notes"
      label="Notes"
      type="text"
      required
      component={RenderTextareaField}
      className="checklist__dateNote--textarea"
      maxChars={1000}
      validate={[Validations.MAX_LENGTH_1000]}
      autoFocus={!isCustomTask}
    />
    <div>
      <ChecklistSaveCancelButtons onCancel={onCancel} />
    </div>
  </form>
);

DateNoteForm.propTypes = {
  initialValues: PropTypes.shape({
    due_at: PropTypes.object,
    notes: PropTypes.string,
  }),
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isCustomTask: PropTypes.bool,
};

DateNoteForm.defaultProps = {};

export default DateNoteForm;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistDateNote/DateNoteForm/DateNoteForm.jsx